// CRA 3 / TS 4.2 cannot consume lucide-react ESM or its .d.ts.
module.exports = require('lucide-react/dist/cjs/lucide-react.js')
